<div class="row same-height">
  @if (strategies$ | async; as strategies) {
    @for (strategy of strategies; track $index) {
      @if ($index >= slideRange[0] && $index <= slideRange[1]) {
        <div class="col">
          <div class="tile">
            <div>
              <div class="headline no-select">{{ strategy.title | transloco }}</div>
              <div class="text no-select">{{ strategy.description | transloco }}</div>
            </div>
            <div>
              <a class="link-secondary no-select" [routerLink]="$index === 0 ? url : url + '/' + strategy.id">
                {{ strategy.link ?? 'my-home.multi-order-strategies-slider.more' | transloco }}
              </a>
            </div>
          </div>
        </div>
        <div class="tile-navigation">
          <button class="left" [disabled]="slideRange[0] === 0" (click)="prev()">
            <svg class="icon icon-18">
              <use xlink:href="/assets/img/svgs/svgset.svg#chevron" />
            </svg>
          </button>
          <button class="right" [disabled]="slideRange[1] === strategies.length - 1" (click)="next()">
            <svg class="icon icon-18">
              <use xlink:href="/assets/img/svgs/svgset.svg#chevron" />
            </svg>
          </button>
        </div>
      }
    }
  }
</div>
<div class="spacer-default"></div>
